<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box "  style="width: 180px;">
					<label for="start-date"><span class="">充值日期<i class="icon_select"></i></span></label>
					<span class="order-query-form-input">
						<el-date-picker 
							v-model="orderForm.rechargeTimeBegin"
							type="datetime"
							placeholder="选择日期"
							name="start-date"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker
							v-model="orderForm.rechargeTimeEnd"
							type="datetime"
							placeholder="选择日期时间"
							class="setTimePicker"
							value-format="yyyy-MM-dd HH:mm:ss"
							>
					 	 </el-date-picker>
					</span>
                </div>
                <div class="order-query-form-box">
					<label for="start-date">会员等级：</label>
					<span class="order-query-form-input">
						<el-select v-model="orderForm.level" placeholder="请选择" class="stSetSelect">
							<el-option
							v-for="item in statusList"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">司机手机：</label>
					<span class="order-query-form-input"><input type="text"   v-model="orderForm.phone" name="start-date"></span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:loading="loading"
				:showPage="togglePage"
				:showSummary="true" 
				:count-data="dataTotal"
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
		</div>
		
	</div>
</template>
<script>
import stDialog from '../../components/StDialog'

export default {
	name: 'MarginManage',
	props: [],
	components: {stDialog},
	data(){
		return {
			tableColumns:[
				{
					title:'充值时间',
					key:'rechargeDate',
				},{
					title:'司机手机',
					key:'phone',
				},{
					title:'会员等级',
					key:'levelDesc',
				},{
					title:'充值金额',
					key:'rechargeFee',
				},{
					title:'剩余天数',
					key:'remainDay',
				}
			],
			loading:false,
			bottomHandleArr:[
				{
					label: '导出',
					type: 'success',
					handler: () => this.exportTable()
				},
			],
			pageConfig: {
				total: 0,
				pageSize: 50,
				currentPage: 1,
			},
			dataList:[], //数据列表
			dataTotal: {},
			orderForm:{
				phone: null, 
				rechargeTimeBegin: null,  
                rechargeTimeEnd: null, 
                level: ''
			},
			listPage:{
				currentSize:50,
				current: 1, //分页起始位置
				total: 0, // 总数量
				sizes: [{value:50,label:'每页50条'},{value:100,label:'每页100条'},{value:200,label:'每页200条'},{value:300,label:'每页300条'}], //分页大小
				page:1,
				pages:0,//总页数
            },
            statusList:[{
					value: '',
					label: '全部'
				},{
					value: 'BRONZE',
					label: '青铜'
				}, {
					value: 'PLATINUM',
					label: '白金'
				},{
					value: 'DIAMOND',
					label: '钻石'
				}],
			togglePage:false, //是否显示分页
			selectedList:[],// 选中的列表
		}
	},
	created() {},
	methods: {
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},
		currentChange(currentPage) {
			this.pageConfig.currentPage = currentPage
			this.searchList()
      	},
		getSummaries(param) {
			this.$nextTick(() => {
				this.$refs.table.doLayout();
			});
			let vm = this;
			let sums = [];
			var selectedColm = param.columns;
			let newArray = []
			selectedColm.forEach(a => {
				if (vm.dataTotal[a.property]) {
				newArray.push(vm.dataTotal[a.property])
				} else {
				newArray.push('')
				}
			});
			sums = newArray;
			sums[0] = "合计";
			return sums;
		},
		selectionChange(val){
			this.selectedList=val;
		},
		cellClass(row){     
			
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=JSON.parse(JSON.stringify(this.orderForm))

			orderForm.rechargeTimeBegin = orderForm.rechargeTimeBegin ? new Date(orderForm.rechargeTimeBegin).getTime() : ''
        	orderForm.rechargeTimeEnd = orderForm.rechargeTimeEnd ? new Date(orderForm.rechargeTimeEnd).getTime() : ''
			Object.assign(orderForm,pages)
			this.$server.financial.getDriverMemberRechargeCount(orderForm, (res) => {
				this.dataTotal = res.data
			})
			this.loading=true;
			this.$server.financial.getDriverMemberRechargeRecord(orderForm, (res) => {
					this.loading=false;
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
			})
		},
		
		saveDialogForm(){
			let data={};
			let that=this;
			let selectedLength=this.selectedList.length-1;
			if(this.backPass){
				let setTime=setInterval(()=>{
					data.dataId=that.selectedList[selectedLength].dataId;
					data.remark=this.remark;
					this.$server.financial.marginBackPass(data,(res)=>{ 
						if(res.code!=0){
							that.$toast.stMessage(res.message,false)
						}else{
							that.$toast.stMessage(`设置成功`,true)
						}
					})
					selectedLength--;
					if(selectedLength<0){
						clearInterval(setTime)
						that.searchList();
					}
				},100)
			}else{
				let setTime=setInterval(()=>{
					data.accountId=that.selectedList[selectedLength].id;
					data.remark=this.remark;
					this.$server.financial.marginBackRefuse(data,(res)=>{ 
						if(res.code!=0){
							that.$toast.stMessage(res.message,false)
						}else{
							that.$toast.stMessage(`设置成功`,true)
						}
					})
					selectedLength--;
					if(selectedLength<0){
						clearInterval(setTime)
						that.searchList();
					}
				},100)
			}
			this.toggleStDialog=false;
		},
		// 导出
		exportTable(){
			if (this.dataList.length < 1) {
				this.$toast.stMessage('暂无数据', true)
				return;
			}
			let pages = {};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			const sendData = {
				...this.orderForm,
				exportColumnFiledNames:  this.tableColumns.map((item) => {
					return  item.key
				}).filter(item => {
					return item && item.trim()
				})
			}
			sendData.rechargeTimeBegin = sendData.rechargeTimeBegin ? new Date(sendData.rechargeTimeBegin).getTime() : ''
			sendData.rechargeTimeEnd = sendData.rechargeTimeEnd ? new Date(sendData.rechargeTimeEnd).getTime() : ''
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/finance/driverMemberRechargeExport', sendData, (res) => {
				console.log('导出成功')
			})
		},
	},
	mounted() {
		
	}
}

</script>
<style scoped>
.margin-manage {
  width: 100%;
  height: auto;
}
.data-table-box {
    height: auto;
    background: #FFF;
    padding: 8px;
    box-sizing: border-box;
}	
.data-table{
	margin-bottom: 8px;
}
.query-setting-box-left{
    flex-grow: 0;
}
.order-query-form-box-right{
	margin-left: 24px;
}

.remarkBox{
	width: 100%;
	height: 100px;
	resize: none;
	display: block;
	margin: 1px 0;
	border: 1px solid #DCDCDC;
}
.st-dialog-item-input{
	margin-top: 2px;
}
.st-dialog-form li{
	float: none;
	width: 100%;
}
</style>
